import {autoinject} from 'aurelia-framework';
import {DialogController} from 'aurelia-dialog';

@autoinject()
export class Alert {

    message;
	content = '';
    title: string = 'Alert';
    okButtonText = "Ok";
    
    constructor(private controller:DialogController) {
        this.controller = controller;
        
    }

    activate(options) {
        if (options.message) {
			this.message = options.message;
		}

		if (options.content) {
			this.content = options.content;
		}

        if (options.title) {
            this.title = options.title;
        }
        if (options.okButtonText !== undefined) {
            this.okButtonText = options.okButtonText;
        }
    }
}